import type ExtendedPropertyUri from 'owa-service/lib/contract/ExtendedPropertyUri';
import { getExtendedPropertyUri } from 'owa-service/lib/ServiceRequestUtils';

/** Extended property that contains the Copilot generated Importance Score details */
export const CopilotImportanceScoreExtendedProperty: ExtendedPropertyUri = getExtendedPropertyUri(
    '11000E07-B51B-40D6-AF21-CAA85EDAB1D0',
    'CopilotImportanceScore',
    'Integer'
);
